/*
 * File: PageSubHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:38:40 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Menu, Row, Space } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/store';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    // padding: '0px 50px',
    color: '#84859a',
    fontSize: '1rem',
    // minHeight, not height: below ~700px the customer line and the menu wrap onto two rows and must push the page down, not overlap it.
    // flexShrink 0: this row is a flex item of the full-height Layout, which would otherwise squeeze it back down to minHeight.
    minHeight: 46,
    flexShrink: 0
  },
  menuContainer: {
    height: '100%'
  },
  smallContainer: {
    width: '100%'
  },
  largeContainer: {},
  row2: {
    margin: '0 auto',
    maxWidth: '1920px',
    flex: '1 1 0%',
    alignItems: 'center',
    flexDirection: 'row',
    rowGap: '16px',
    padding: '0 50px'
    // padding: window.innerWidth > 2000 ? '0 50px' : 0
  }
};

export const PageSubHeader = (): JSX.Element => {
  const { acuityContext } = useAppSelector((state) => state.app);
  const { pathname } = useLocation();
  const [selectedMenu, setSelectedMenu] = useState<string>('search');
  const isPosted = pathname.includes('posted');
  const isDefectivePage = pathname.includes('defective-returns');
  const isCreate = pathname.includes('create');

  const showDetails = isPosted || isDefectivePage;

  const featureMenuJSX = (
    <Menu
      disabledOverflow={true}
      mode="horizontal"
      theme="dark"
      style={showDetails ? styles.largeContainer : styles.smallContainer}
      activeKey={selectedMenu}
      defaultSelectedKeys={[selectedMenu]}
      selectedKeys={[selectedMenu]}>
      <Menu.Item key="reports">
        <Link to="/reports">Reports</Link>
      </Menu.Item>
      <Menu.Item key="search">
        <Link to="/">Search</Link>
      </Menu.Item>
      <Menu.Item key="create">
        <Link to="/create">Create</Link>
      </Menu.Item>
      {showDetails && (
        <Menu.Item key="details" disabled={!pathname.includes('/edit/') && !pathname.includes('/orders/') && !pathname.includes('/details/')}>
          Details
        </Menu.Item>
      )}
    </Menu>
  );

  useEffect(() => {
    if (pathname.includes('/create') && !isDefectivePage && !isPosted && !pathname.includes('/reports')) setSelectedMenu('create');
    if (pathname.includes('/') && !isDefectivePage && !isPosted && !isCreate && !pathname.includes('/reports')) setSelectedMenu('search');
    if (pathname.includes('/reports') && !isDefectivePage && !isPosted && !isCreate) setSelectedMenu('reports');
    if (isPosted && !isCreate && !pathname.includes('/reports')) setSelectedMenu('details');
    if (isDefectivePage && !isCreate && !pathname.includes('/reports')) setSelectedMenu('details');
  }, [isCreate, isDefectivePage, isPosted, pathname]);

  return (
    <Row style={styles.row} justify="center" align="middle">
      <Row style={styles.row2} justify="space-between" align="middle">
        <Col>
          <Space size="large">{`${acuityContext?.selectedCustomer?.name} - ${acuityContext?.selectedCustomer?.erpId}`}</Space>
        </Col>
        <Col>{featureMenuJSX}</Col>
      </Row>
    </Row>
  );
};
